import { apiCall } from '@/lib/api-client';

/**
 * A6 · #167 (Tanda A, 2026-10-22) — los familiares del agente que esperan la
 * validación del uploader («Esperando subida a FindHelp» en Inicio).
 *
 * El contador estaba clavado en 50: el server manda a lo sumo 50 filas (las
 * que se pueden mirar) y la web contaba el largo de la lista. Ahora se pide
 * `?withTotal=1` y el número sale del COUNT del server.
 *
 * `normalizarPendientes` acepta las DOS formas a propósito: si la web nueva
 * llega antes que el API nuevo (promote en dos pasos), el API viejo ignora el
 * parámetro y responde el array de siempre — se cuenta como antes, sin
 * reventar la pantalla.
 */
export interface PendingValidationRow {
  subScreeningId: string;
  submittedAt: string;
  hoursSinceSubmit: number;
  hmFullName: string;
  parentClientLastName: string;
  parentClientCinLast6: string;
}

export interface PendingValidations {
  rows: PendingValidationRow[];
  /** El total REAL (COUNT del server); puede ser mayor que `rows.length`. */
  total: number;
}

export function normalizarPendientes(data: unknown): PendingValidations {
  if (Array.isArray(data)) {
    return { rows: data as PendingValidationRow[], total: data.length };
  }
  if (data && typeof data === 'object' && Array.isArray((data as { items?: unknown }).items)) {
    const d = data as { items: PendingValidationRow[]; total?: unknown };
    const total = Number(d.total);
    return {
      rows: d.items,
      total: Number.isFinite(total) ? Math.max(total, d.items.length) : d.items.length,
    };
  }
  return { rows: [], total: 0 };
}

export function fetchPendingValidations(): Promise<PendingValidations> {
  return apiCall<unknown>('/agents/me/pending-validations?withTotal=1').then(normalizarPendientes);
}
